import { Container } from "@mui/system";
import { Grid, Paper, TextField, Typography, Box, Button, Switch } from "@mui/material";
import React, { useEffect } from "react";
import globals from "../globals";
import EmailField from "../components/login/email_tf";
import PasswordField from "../components/login/password_tf";
import { styled } from '@mui/material/styles';
import { useAuth } from "../context/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";

const LoginPage = () => {

    const [wrongCredentials, setWrongCredentials] = React.useState(false);
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [rememberMe, setRememberMe] = React.useState(false);
    const { login, user } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirectParam = searchParams.get("redirect");
    // Only follow same-site paths ("/webinar/x"), never "//evil.com" or full URLs.
    const safeRedirect = redirectParam && redirectParam.startsWith("/") && !redirectParam.startsWith("//")
        ? redirectParam
        : null;
    const redirectTo = safeRedirect || "/dashboard";

    const getDefaultProfileRoute = (currentUser) =>
        currentUser?.role?.toLowerCase() === "admin" ? "/admin-dashboard" : "/dashboard";

    useEffect(() => {
        if (user) {
            // Back to the page that sent the user to log in (e.g. a webinar), otherwise their profile.
            navigate(safeRedirect || getDefaultProfileRoute(user));
        }
    }, [user]);

    const handleLogin = (e) => {
        e.preventDefault();
        //console.log(email, password);
        fetch(globals.apiUrl + "/auth/login", {
            method: "POST",
            body: JSON.stringify({ email, password, remember_me: rememberMe }),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                }

                setWrongCredentials(true);
                throw new Error("Invalid email or password");

            })
            .then(response => {
                login(response);
            })
            .catch(error => {
                //console.log("error");
                //console.log(error);
            });
    }

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const SignInSwitch = styled(Switch)(({ theme }) => ({
        '& .MuiSwitch-switchBase.Mui-checked': {
            color: globals.colors.darkBlue,
            '&:hover': {
                backgroundColor: globals.colors.lightBlue,
            },
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: globals.colors.backgroundColor,
        },
    }));

    const label = { inputProps: { 'aria-label': 'Color switch demo' } };

    return (
        <Container maxWidth="lg"
            disableGutters
            sx={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'column',
                height: 'calc(100vh - 20px)',
                width: '100%',
            }}>
            <img src='login_page_owl.webp' loading="lazy" decoding="async" style={{ position: 'fixed', bottom: 0, right: 0, height: "min(45vw, 45vh)", width: 'auto', zIndex: 1 }} />
            <img src='login_page_earth.webp' loading="lazy" decoding="async" style={{ position: 'fixed', top: '10%', left: 0, height: "min(55vw, 55vh)", width: 'auto', zIndex: 1 }} />
            <Grid container justifyContent={'center'}>
                <Grid item xs={12} sm={6} md={4} justifyContent={'center'} alignItems={'center'} display={'flex'}>
                    <a href='/'><img src='eacademiabg-logo.webp' style={{ height: 100 }} /></a>
                </Grid>
            </Grid>

            <Grid container justifyContent={'center'} sx={{ mt: 5, zIndex: 2 }}>
                <Grid item xs={12} sm={10} md={10} justifyContent={'center'} alignItems={'center'} display={'flex'} textAlign={'center'}>
                    <Paper elevation={8} sx={{ backgroundColor: globals.colors.lightRed, borderRadius: 2, padding: 2, width: '70%' }}>
                        <Typography sx={{ color: globals.colors.backgroundColor, fontSize: 30, fontWeight: 'bold' }}>Здравей отново!</Typography>
                        <Typography sx={{ color: globals.colors.backgroundColor, fontSize: 20, mt: 2 }}>Влез, за да продължиш своето онлайн обучение.</Typography>
                        <Box component="form" sx={{ mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', '& .MuiTextField-root': { m: 1, width: '25ch' } }} onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
                            {wrongCredentials && <Typography sx={{ color: globals.colors.darkRed, fontSize: 16, mt: 2, WebkitTextStroke: '0.5px black' }}>Грешен имейл или парола!</Typography>}
                            <EmailField onChange={e => setEmail(e.target.value)} />
                            <PasswordField onChange={e => setPassword(e.target.value)} />
                            <Typography sx={{ mt: 3 }}><a href="/change-pass" style={{ color: globals.colors.backgroundColor, fontWeight: 'bold' }}>Забравена парола?</a></Typography>
                            <Grid container justifyContent={'center'} alignItems={'center'} sx={{ mt: 2 }}>
                                <SignInSwitch {...label} checked={rememberMe} onChange={e => { console.log(e.target.checked); setRememberMe(e.target.checked) }} />
                                <Typography sx={{ color: globals.colors.textColor, fontWeight: 'bold' }}>Дръж ме вписан в сайта</Typography>
                            </Grid>
                            <Button onClick={handleLogin} variant='contained' href='#' type='submit' size='large' sx={{
                                mt: 3, px: 5, backgroundColor: globals.colors.darkBlue, '&:hover': {
                                    backgroundColor: globals.colors.lightBlue,
                                },
                            }}> Вход</Button>
                            <Grid container justifyContent={'center'} alignItems={'center'} sx={{ mt: 5 }}>
                                <Typography sx={{ color: globals.colors.backgroundColor, fontWeight: 'bold' }}>Нямаш профил?</Typography>
                                <Typography sx={{ mx: 1 }}><a href={redirectTo !== '/dashboard' ? `/register?redirect=${encodeURIComponent(redirectTo)}` : '/register'} style={{ color: globals.colors.backgroundColor, fontWeight: 'bold' }}>Регистрирай се сега!</a></Typography>
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
}

export default LoginPage;